


$(".top-hero-topics__close").click(function() {
  $('.top-hero-topics').fadeOut('slow');
});


//let lead_height = $(".top-lead__list").innerHeight();
//$(".top-lead__inner").css('height', lead_height - 20)